import "./About.css"
import Gorilla from "../assets/Gorilla.jpg"
import Yato from "../assets/yato.jpg"
import Mkt from "../assets/mkt.jpg"
import { Link } from "react-router-dom"

const About = () => {
    return(
        <div className="About">
            <h3>Contributors</h3>
            <div className="cardContainer">
                <div className="card">
                    <img src={Gorilla} alt="" />
                    <h4>Gorilla</h4>
                    <h5>Creative Coordinator</h5>
                </div>
                <div className="card">
                    <img src={Mkt} alt="" />
                    <h4>Myo Kyaw Tun</h4>
                    <h5>Graphic Designer</h5>
                </div>
                <div className="card">
                    <img src={Yato} alt="" />
                    <h4>Yato</h4>
                    <h5>Developer</h5>
                </div>
            </div>
            <p className="AboutText">This project idea is inspired by <a href="https://www.barbieselfie.ai/intl/" target="_blank" rel="noopener noreferrer">barbieselfie.ai</a></p>
            <Link to={"/"} className="backHome">Back to home</Link>
        </div>
    )
}

export default About